const AccountsPanel = ({ children, className, ...props }) => (
  <div className={`account-panel ${className}`} {...props}>
    {children}
  </div>
);

export default AccountsPanel;
